/**
 * description: 节假日与周末工作日维护
 * author: bql
 * 2023/5/4 17:02
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceHolidayApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'attendance-holiday'
    }

    /**
     * 验证是否在工作日内
     * @param now
     */
    public getHolidayList(now) {
        return this.send({now: now}, "getHolidayList", this.Methods.GET)
    }

    /**
     * 周末工作日
     * @param now
     */
    public getWeekendWork(year) {
        return this.send({year: year}, "getWeekendWork", this.Methods.GET)
    }

}
